// Actions
import {
  SESSION_SET_CURRENT_CUSTOMER,
  SESSION_SET_LISTING_TYPE,
  SESSION_SET_LISTASYNCPROCESS,
  SESSION_ADD_LISTASYNCPROCESS,
  SESSION_REMOVE_LISTASYNCPROCESS,
  SESSION_CLEAN_LISTASYNCPROCESS,
  SESSION_UPDATE_LISTASYNCPROCESS,
} from '../actionTypes';

// @todo Site, area an so on are not stored in session anymore. Need to remove.
export const initialState = {
  customer: null,
  listingType: 'table',
  listAsyncProcess: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    /** Sets the current customer */
    case SESSION_SET_CURRENT_CUSTOMER:
      return {
        ...state,
        customer: action.payload,
      };

    /** Sets the listing type */
    case SESSION_SET_LISTING_TYPE:
      return {
        ...state,
        listingType: action.payload,
      };

    /** Sets the listing type */
    case SESSION_SET_LISTASYNCPROCESS:
      return {
        ...state,
        listAsyncProcess: action.payload,
      };

    /** Sets the listing type */
    case SESSION_ADD_LISTASYNCPROCESS:
      const newAsyncListArray = state.listAsyncProcess && state.listAsyncProcess.length
        ? [...state.listAsyncProcess]
        : [];
      newAsyncListArray.push(action.payload);
      return {
        ...state,
        listAsyncProcess: newAsyncListArray,
      };

    /** Sets the listing type */
    case SESSION_REMOVE_LISTASYNCPROCESS:
      const newRemovedAsyncListArray = state.listAsyncProcess && state.listAsyncProcess.length
        ? [...state.listAsyncProcess]
        : [];
      newRemovedAsyncListArray.splice(
        newRemovedAsyncListArray.findIndex(
          (el) => el.asyncTask.idAsyncTask === action.payload.asyncTask.idAsyncTask,
        ),
        1,
      );
      return {
        ...state,
        listAsyncProcess: newRemovedAsyncListArray,
      };

    /** Sets the listing type */
    case SESSION_UPDATE_LISTASYNCPROCESS:
      const updatedAsyncListArray = state.listAsyncProcess && state.listAsyncProcess.length
        ? [...state.listAsyncProcess]
        : [];
      const index = updatedAsyncListArray.findIndex(
        (task) => task.asyncTask.idAsyncTask === action.payload.asyncTask.idAsyncTask,
      );
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(index)) {
        updatedAsyncListArray[index] = action.payload;
      }
      return {
        ...state,
        listAsyncProcess: updatedAsyncListArray,
      };

    /** Sets the listing type */
    case SESSION_CLEAN_LISTASYNCPROCESS:
      return {
        ...state,
        listAsyncProcess: [],
      };

    default:
      return state;
  }
};
